import {NgModule, ModuleWithProviders, CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import { CommonModule } from '@angular/common';
import { BreadcrumbComponent } from './breadcrumb.component';
import { BreadcrumbService } from './breadcrumb.service';
import { NavService } from '../../_services/_nav.service';

export * from './breadcrumb.component';
export * from './breadcrumb.service';

@NgModule( {
              imports: [
                 CommonModule
              ],
              declarations: [
                 BreadcrumbComponent
              ],
              exports: [
                 BreadcrumbComponent
              ]
           } )
export class BreadcrumbModule {
   static forRoot(): ModuleWithProviders<BreadcrumbModule> {
      return {
         ngModule: BreadcrumbModule,
         providers: [ BreadcrumbService ]
      };
   }
}
